import * as React from 'react'
import { Box, Stack } from '@mui/material'
import ValidationAccount from '../../components/ValidationAccount'
import ImagenBackground from '../../assets/images/arbol-ec/fondos/DJI_05.jpeg'

const styleStack = {
  justifyContent: 'center',
  direction: 'column',
  alignItems: 'center',
  py: 2,
  px: '8vw',
  height: '100%',
  spacing: 2,
  width: '100%',
}

const styleBox = {
  backgroundImage: `url(${ImagenBackground})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  width: 'inherit',
  minHeight: '100vh',
}

const AuthorizeAccountPage = () => {
  return (
    <Box component="div" style={styleBox}>
      <Stack {...styleStack}>
        <ValidationAccount />
      </Stack>
    </Box>
  )
}

export default AuthorizeAccountPage
